import { Loader2, ShieldAlert } from "lucide-react";

export function AdminAccountSwitchCard({
  email,
  isSwitching,
  onSwitch,
}: {
  email?: string;
  isSwitching: boolean;
  onSwitch: () => void | Promise<void>;
}) {
  return (
    <div
      className="rounded-2xl border border-amber-400/20 bg-[#0a0a12] px-6 py-8 text-center shadow-[0_0_80px_hsl(38_90%_50%/0.05)]"
      data-testid="admin-account-switch"
    >
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-amber-400/20 bg-amber-400/10">
        <ShieldAlert aria-hidden="true" className="h-6 w-6 text-amber-300" />
      </div>
      <h2 className="mt-4 text-lg font-semibold text-white">Use an administrator account</h2>
      <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-white/55">
        {email ? (
          <>
            You’re currently signed in as <span className="font-medium text-white/80">{email}</span>, but
            this account does not have Health Administration access.
          </>
        ) : (
          "The account currently signed in could not be confirmed as a Health Administration account."
        )}
      </p>
      <button
        className="mt-5 inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-black transition-colors hover:bg-primary/90 disabled:cursor-wait disabled:opacity-60"
        disabled={isSwitching}
        onClick={() => void onSwitch()}
        type="button"
      >
        {isSwitching && <Loader2 aria-hidden="true" className="h-4 w-4 animate-spin" />}
        {isSwitching ? "Signing out…" : "Sign out and use another Google account"}
      </button>
      <p className="mt-3 text-xs text-white/35">
        You’ll return to Admin sign in and can choose Google again.
      </p>
    </div>
  );
}